import { all, fork } from 'redux-saga/effects';
import { watchCommonContent, watchHome } from './saga/HomeSaga';
import { watchCheckAuth, watchLogout, watchLogin, watchSignup, watchUpdateCustomer,watchDeleteAddress,watchUpdateAddress,watchAddAddress, watchResetPassword, watchForgotPassword } from './saga/AuthSaga';
import { languageSaga } from './saga/LanguageSaga';
import { keepAlive } from './sagaUtils';

// Each watcher is wrapped in keepAlive so an uncaught error in one of them
// restarts that watcher instead of killing the whole root saga.
export function* rootSaga() {
    yield all([
        watchHome,
        watchCommonContent,
        languageSaga,
        watchSignup,
        watchLogin,
        watchCheckAuth,
        watchLogout,
        watchUpdateCustomer,
        watchAddAddress,
        watchUpdateAddress,
        watchDeleteAddress,
        watchResetPassword,
        watchForgotPassword,
    ].map(watcher => fork(keepAlive(watcher))))
}
